
export enum actionTypes {
    //FetchVideoGroups
    FETCH_AVATAR_IAMGE_REQUEST = 'FETCH_AVATAR_IAMGE_REQUEST',
    FETCH_AVATAR_IAMGE_SUCCESS = 'FETCH_AVATAR_IAMGE_SUCCESS',
    FETCH_AVATAR_IAMGE_FAIL = 'FETCH_AVATAR_IAMGE_FAIL',
    //CreateVideoGroup
    CREATE_AVATAR_IAMGE_REQUEST = 'CREATE_AVATAR_IAMGE_REQUEST',
    CREATE_AVATAR_IAMGE_SUCCESS = 'CREATE_AVATAR_IAMGE_SUCCESS',
    CREATE_AVATAR_IAMGE_FAIL = 'CREATE_AVATAR_IAMGE_FAIL',
    //DeleteVideoGroup
    DELETE_AVATAR_IAMGE_REQUEST = 'DELETE_AVATAR_IAMGE_REQUEST',
    DELETE_AVATAR_IAMGE_SUCCESS = 'DELETE_AVATAR_IAMGE_SUCCESS',
    DELETE_AVATAR_IAMGE_FAIL = 'DELETE_AVATAR_IAMGE_FAIL',
}

export interface GenericGroupStateProps {
    isLoading: boolean;
    status: stateStatusType | null;
    error: string | null;
}

export enum stateStatusType {
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}

export interface GroupInput {
    name: string;
    description: string;
    group_order: number;
    imageFile?:File;
    image?:string
    icon?:string;
}
export interface GroupError {
    name?: string;
    group_order?:string;
    description?: string;
}

export interface AvatarImageProps {
    avatar_image_url: string;
    id: string;
}
export interface FetchAvatarImageRequestAction {
    type: actionTypes.FETCH_AVATAR_IAMGE_REQUEST;
}

export interface FetchAvatarImageSuccessAction {
    type: actionTypes.FETCH_AVATAR_IAMGE_SUCCESS;
    payload: AvatarImageProps[];
}

export interface FetchAvatarImageFailureAction {
    type: actionTypes.FETCH_AVATAR_IAMGE_FAIL;
    payload: string;
}
//CreateVideoGroup
export interface CreateAvatarImageRequestAction {
    type: actionTypes.CREATE_AVATAR_IAMGE_REQUEST;
}

export interface CreateAvatarImageSuccessAction {
    type: actionTypes.CREATE_AVATAR_IAMGE_SUCCESS;
    payload: AvatarImageProps;
}
export interface CreateAvatarImageFailAction {
    type: actionTypes.CREATE_AVATAR_IAMGE_FAIL;
    payload: string;
}
//DeleteAvatarImage
export interface DeleteAvatarImageRequestAction {
    type: actionTypes.DELETE_AVATAR_IAMGE_REQUEST;
}

export interface DeleteAvatarImageSuccessAction {
    type: actionTypes.DELETE_AVATAR_IAMGE_SUCCESS;
    payload: string;
}

export interface DeleteAvatarImageFailAction {
    type: actionTypes.DELETE_AVATAR_IAMGE_FAIL;
    payload: string;
}
export interface CreateAvatarImageFailAction {
    type: actionTypes.CREATE_AVATAR_IAMGE_FAIL;
    payload: string;
}



export type VideoGroupsActions =
    | FetchAvatarImageRequestAction
    | FetchAvatarImageSuccessAction
    | FetchAvatarImageFailureAction
    | CreateAvatarImageRequestAction
    | CreateAvatarImageSuccessAction
    | CreateAvatarImageFailAction
    | DeleteAvatarImageRequestAction
    | DeleteAvatarImageSuccessAction
    | DeleteAvatarImageFailAction;
